import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { SIGN_UP } from "../../graphql/mutations/signUp";
import TextFields, {
  DropDownTextField,
} from "../../components/TextField/text-field.component";

import {
  SignUpContainer,
  HeaderContainer,
  NestedModalContainer,
  SignUpTextContainer,
  AccountInformation,
  CreateAccountText,
  FirstInputContainer,
  SecondInputContainer,
  ThirdInputContainer,
  ButtonsContainer,
  BackContainer,
  ErrorContainer,
  AtLeastText,
  Requirement,
  RequirementText,
  SpecialRequirement,
  GoBackText,
  LargeInput,
  Label,
  PhoneBox,
  Container,
} from "./BusinessSignup.styles";
import Buttons from "../../components/Button/button.component";
import { colors } from "../../theme/color";
import { emailRegex } from "../../utils/EmailValidation";
import { checkPasswordStrength } from "../../utils/input";
import { useDispatch } from "react-redux";
import { setUserData } from "../../store/user";

const BusinessSignUp = () => {
  const dispatch = useDispatch();
  const [register, { loading }] = useMutation(SIGN_UP);
  const navigate = useNavigate();
  const [data, setData] = useState({
    businessName: "",
    businessType: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [smallInputForm, setSmallInputForm] = useState("");
  const [phone, setPhone] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [isValidEmail, setIsValidEmail] = useState(true);

  const handleOptionChange = (value: string) => {
    setSelectedOption(value);
  };

  const dropdownOptions = [
    { value: "1", label: "Sole Proprietorship" },
    { value: "2", label: "Single-Member LLC" },
    { value: "3", label: "Multi-Member LLC" },
    { value: "4", label: "Private Partnership" },
    { value: "5", label: "Private Corporation" },
    { value: "6", label: "Others" },
  ];

  const dropdownOptionsPhoneNumber = [
    { value: "nigeria", label: "+234" },
    { value: "ghana", label: "+233" },
  ];
  const handleNameChange = (key: string, value: string) => {
    setData((prevData) => ({
      ...prevData,
      [key]: value,
    }));
    setIsValidEmail(emailRegex.test(value));
  };

  const handlePhoneChange = (value: string) => {
    setPhone(value);
  };

  const isFormValid = () => {
    return (
      data.businessName !== "" &&
      data.businessType !== "" &&
      data.email !== "" &&
      // isValidEmail &&
      phone !== "" &&
      data.password !== "" &&
      data.confirmPassword !== "" &&
      data.password === data.confirmPassword
    );
  };

  const isFormEmpty = () => {
    return smallInputForm === "";
  };

  const NavigateToTypeOfAccount = () => {
    navigate("/auth/type-of-account");
  };

  const toHomePage: () => void = () => {
    navigate("/");
  };

  const NavigateToOtp = () => {
    navigate("/otp");
  };
  const [errors, setErrors] = useState<{ [key: string]: any }>({});

  React.useEffect(() => {
    const passwordStrength = checkPasswordStrength(data.password);
    setErrors({
      ...errors,
      ...passwordStrength,
      ...passwordStrength?.criteriaResults,
    });
  }, [data]);
  const handleLogin = async () => {
    try {
      const response = await register({
        variables: {
          input: {
            email: data.email,
            phone,
            organizationType: data.businessName,
            organizationName: data.businessName,
            password: data.password,
            confirmPassword: data.confirmPassword,
          },
        },
      });
      console.log(response.data.register);
      // const localStorageDetails = {
      //   organizationId: response.data.register.organizationId,
      //   id: response.data.register.id,
      //   email: data.email,
      // };
      if (response.data.register.message === "Proceed to verify your account") {
        const organizationId = response.data.register.organizationId;
        const id = response.data.register.id;
        const email = data.email;
        dispatch(setUserData({ organizationId, id, email }));
        // setLocalStorageData(
        //   "organizationId",
        //   localStorageDetails.organizationId
        // );
        // setLocalStorageData("id", localStorageDetails.id);
        // setLocalStorageData("email", localStorageDetails.email);

        navigate("/otp");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Container>
      <HeaderContainer>
        <img onClick={toHomePage} src="/assets/icons/fipaylogo.png" />
      </HeaderContainer>
      <BackContainer>
        <img src="/assets/svg/goBack.svg" />
        <GoBackText onClick={NavigateToTypeOfAccount}>Go back</GoBackText>
      </BackContainer>
      <SignUpContainer>
        <NestedModalContainer>
          <SignUpTextContainer>
            <AccountInformation>
              Provide the account information below
            </AccountInformation>
            {/* <AccountInformation>below</AccountInformation> */}
            <CreateAccountText>
              Fill in the details to create an account
            </CreateAccountText>
          </SignUpTextContainer>
          <FirstInputContainer>
            <TextFields
              type="text"
              placeholder="Quantum Incorporation"
              label="Business Name"
              value={data.businessName}
              onChange={(value: string) =>
                handleNameChange("businessName", value)
              }
            />
            <DropDownTextField
              label="Business Type"
              value={data.businessType}
              onChange={(value: string) =>
                handleNameChange("businessType", value)
              }
              placeholder="Select business type"
              options={dropdownOptions}
            />
          </FirstInputContainer>
          <SecondInputContainer>
            <TextFields
              type="email"
              placeholder="quantuminc@gmail.com"
              label="Email Address"
              value={data.email}
              onChange={(value: string) => handleNameChange("email", value)}
            />
            <PhoneBox>
              <Label htmlFor="countryCode">Business Phone Number</Label>
              <LargeInput
                type="tel"
                onChange={handlePhoneChange}
                value={phone}
                defaultCountry="US"
                maxLength={14}
              />
            </PhoneBox>
            {/* {phone number dropdown */}
          </SecondInputContainer>
          <ThirdInputContainer>
            <TextFields
              type="password"
              placeholder="●●●●●●●●"
              label="Password"
              value={data.password}
              onChange={(value: string) => handleNameChange("password", value)}
            />
            <TextFields
              type="password"
              placeholder="●●●●●●●●"
              label="Confirm Password"
              value={data.confirmPassword}
              onChange={(value: string) =>
                handleNameChange("confirmPassword", value)
              }
              autoComplete="off"
            />
          </ThirdInputContainer>
          <ErrorContainer>
            <AtLeastText>AT LEAST :</AtLeastText>
            <Requirement>
              <RequirementText $active={errors.length}>
                8 characters
              </RequirementText>
              <RequirementText $active={errors.uppercase}>
                An uppercase letter
              </RequirementText>
              <RequirementText $active={errors.lowercase}>
                A lowercase letter
              </RequirementText>
            </Requirement>
            <SpecialRequirement>
              <RequirementText $active={errors.special}>
                A special character
              </RequirementText>
              <RequirementText $active={errors.numeric}>
                A number
              </RequirementText>
            </SpecialRequirement>
          </ErrorContainer>
          <ButtonsContainer>
            <Buttons
              handleClick={handleLogin}
              label={loading ? "Creating Account..." : "Continue"}
              width="45%"
              color={colors.ButtonBackgroundColors.primaryMediumHoverButton}
              cursor="pointer"
              border="30px"
              height="40px"
              disabled={!isFormValid() || loading || !errors?.pass}
            />
          </ButtonsContainer>
        </NestedModalContainer>
      </SignUpContainer>
    </Container>
  );
};

export default BusinessSignUp;
